import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: frankgrinaert
 * id 2DEA5CA1-8412-4DA4-95C4-7E1AA2C27404
 * name exclamation-thick
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/exclamation-thick.svg
 * tags
 */
export const ExclamationThickIcon = createSvgIcon(<><path d="M10 3H14V14H10V3M10 21V17H14V21H10Z" /></>, 'ExclamationThickIcon');
export default ExclamationThickIcon